import React from 'react';
import { SafeHtml } from 'src/components/SafeHtml/SafeHtml';
import { applyCssModuleClasses } from 'src/util/applyCssModuleClasses';

import classes from './InfoCard.scss';
import deliveryPageClasses from './CmsDeliveryPage.scss';

type Props = {
    data?: string;
};

export const CmsDeliveryTab: React.FC<Props> = ({ data }) => {
    const html = applyCssModuleClasses(data || '', classes, deliveryPageClasses);
    return (
        <div className={classes.container}>
            <SafeHtml html={html} />
        </div>
    );
};
